import { z } from 'zod';

// Additional per-user emails (UCH-442). Match-only — used to link Firebase App
// Distribution testers to hera users — never for auth. Stored lowercase.
export const UserEmailInputSchema = z.string().trim().toLowerCase().pipe(z.string().email());

export const UserEmailSchema = z.object({
  id: z.string().uuid(),
  email: z.string(),
  createdAt: z.string(),
});
export type UserEmailRow = z.infer<typeof UserEmailSchema>;
